/**
 * Button to take the user to the map page almost all times - it's floating on the search results until it smoothly slots into position in the placeholder on the page once scrolled into view.
 */
const ShowMapButton = (function () {
  // DOM elements
  const buttonPlaceholder = document.querySelector('.js-show-map-placeholder')
  const showMapBtn = document.querySelector('.js-show-map')

  const initShowMapButton = () => {
    // create the observer
    // 86px is height of button placeholder(54px button + 32px margin )
    const observer = new window.IntersectionObserver(handleScroll, { rootMargin: `-86px`, threshold: 0 })
    // give the observer some dom nodes to keep an eye on
    observer.observe(buttonPlaceholder)

    if (showMapBtn) {
      showMapBtn.addEventListener('click', handleClick)
    }
  }

  /**
   * Scroll user to top of the page while the button/link redirects to map page.
   */
  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
    showMapBtn.blur()
  }

  let direction = 'up'
  let prevYPosition = 0

  /**
   * Determine current direction of user scrolling
   * @param {number} currentScrollYPosition
   * @returns {boolean}
   */

  const setScrollDirection = () => {
    if (window.scrollY > prevYPosition) {
      direction = 'down'
    } else {
      direction = 'up'
    }

    prevYPosition = window.scrollY
  }
  /**
   * Position the button in it's placeholder (via adding CSS class, changing position value) only when placeholder has scrolled into view.
   */
  const handleScroll = (entries) => {
    entries.forEach((entry) => {
      setScrollDirection()
    })

    if (entries[0].isIntersecting) {
      // If placeholder is view
      showMapBtn.classList.add('c-floating-button__btn--static')
    } else if (direction == 'down') {
      // If placeholder is out of view but scrolling down ie. in footer
      showMapBtn.classList.add('c-floating-button__btn--static')
    } else {
      showMapBtn.classList.remove('c-floating-button__btn--static')
    }
  }

  return {
    init: () => {
      const showMapBtn = document.querySelector('.js-show-map')
      if (showMapBtn) {
        initShowMapButton()
      }
    },
  }
})()

export default ShowMapButton
